
import dayjs from 'dayjs';
export const formatDate = (date: any) => {
  return date ? dayjs(date).format('YYYY-MM-DD') : '';
};


export const customDateRangeFilter = (row: any, columnId: string, filterValue: Date | null) => {
  const startDate = formatDate(filterValue);
  const dateValue = formatDate(row.original[columnId] ? new Date(row.original[columnId]) : null);
  return startDate === dateValue
};

export const sortData = (data: any[], column: string, desc: boolean = false) => {
    if(typeof column !== 'undefined' && typeof desc !== 'undefined') {
      return data?.sort((a, b) => {
        const valueA = a[column];
        const valueB = b[column];
    
        if (valueA < valueB) return desc ? 1 : -1;
        if (valueA > valueB) return desc ? -1 : 1;
        return 0;
      });
    }
    return data
};

const dateColumnList  = ["ServiceDate", "PatientBirthDate", "FilingDeadline", "NoteDate", "MEDTerminationDate"]

export const RemoveTimeFromDate = (row : any) => {
  dateColumnList.forEach((element : any) => {
      if(typeof row[element] !== 'undefined') {
        row[element] =  formatDate(row[element])
      }   
   });

   return row;
}

export type Claim = {
    RowId: number;
    CMContact: string;
    RenderingProviderContact : string
    CECContact: string;
    RCDContact : string;
    GMContact: string;
    DMContact : string;
    ClaimId: number;
    CarrierName: string;
    ProviderFirstAndLastName: string;
    OfficeNum : string;
    Region : string;
    District: string;
    ServiceDate :  Date | string | null;
    PatientFirstLastName : string;
    PatientBirthDate : string | null;
    NoteDate : string;
    FilingDeadline : string | null;
    Note: string;
    TimelyFillingLimit : string;
    PosPrimaryDx : string;
    MEDTerminationDate : string | null;
    UpdatedProcedureCode : string;
    UpdatedDiagnosisCode : string;
    AdditionalNotes : string;
    EEHRUpdated : string;
    ActionNeededBy: string;
    Status : string;
    CCTNotes : string;
    EEHRAccurateNoUpdateNeeded : string;
    RenderingProviderNPI : string;
    IsVEHClaim : string;
    CanEdit : boolean;
    MCMContact: string;
    ModifiedBy?: string;
    ModifiedDate?: string;
  };

  export type UpdatedClaim = {
    ClaimId : Number,
    EEHRUpdated : any,
    StatusTypeId : Number,
    UpdatedDiagnosisCode : string,
    UpdatedProcedureCode : string,
    AdditionalNotes : string,
    ModifiedBy : string | undefined
  };

  export type CancelClaim = {
    ClaimId : Number,
    StatusTypeId :  Number,
    ModifiedBy : string | undefined
  };

  export enum StatusTypes {
    Received = 1,
    In_Progress = 2,
    No_EEHRUpdate_Required = 3,
    Reassign_To_OD = 4,
    Procedure_Code_Updated = 5,
    ICD10_Code_Updated  = 6,
    Return_Rekey_Complete = 7,
    Completed = 8,
    CANCELLED = 9,
    Procedure_and_ICD10_Code_Updated = 10,
    No_Addendum = 11,
    Archived=12,
    AssigntoGM=13  

  }
export const handleYesNoCellValue = (cell : any) => {
      if(cell === "" || typeof cell === 'undefined' || cell === null ) {
        return ""
      }
      else {
        return cell === "Y" ? "N" : "Y"
      }
}

export const handleBooleanCellValue = (cell : any) => {
  if(cell === "" || typeof cell === 'undefined' || cell === null ) {
    return ""
  }
  else {
    return cell  ? "Y" : "N"
  }
}

export const getFontColorBasedOnODTerminationdate = (MEDTerminationDate: any) => {
   if(MEDTerminationDate === "" || typeof MEDTerminationDate === 'undefined' || MEDTerminationDate === null) {
      return ''
   }
   else {
     const currentDate  =  new Date()?.toISOString().split('T')[0]
     const medTerminationdate = new Date(MEDTerminationDate)?.toISOString().split('T')[0]
     return currentDate > medTerminationdate ? '' : 'red'
   }
}

export interface TableStateStorage {
  columnFilters: [];
  sorting: [];
  columnOrder: [];
}

export const STORAGE_KEY = 'TableStateStorage';

export const loadSavedSetting = (userRole: string, selectedTab: string): any => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const allSettings = raw ? JSON.parse(raw) : [];
    
    const found = allSettings.find(
      (item: any) => item.userRole === userRole && item.selectedTab === selectedTab
    );
    
    const savedSettings = found?.savedSettings || {};
  
    savedSettings.columnVisibility = {
      ...(savedSettings.columnVisibility || {}),
      StatusTypeId: false, // Force the column to be hidden
    };
    
    return savedSettings;
  } catch {
    return {};
  }
};

export const isCCTUser = (currentRole : any ) => {
  return currentRole?.toUpperCase() === "ICD10_CCT"
}

export const saveSettingForCombo = (
  userRole: string,
  selectedTab: string,
  tableState: any
) => {
  let allSettings: any[] = [];

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    allSettings = raw ? JSON.parse(raw) : [];
  } catch {
    allSettings = [];
  }

  const index = allSettings.findIndex(
    (item) => item.userRole === userRole && item.selectedTab === selectedTab
  );

  const savedSettings = {
    columnFilters: tableState?.columnFilters ?? [],
    columnVisibility: {
      ...(tableState?.columnVisibility ?? {}),
      StatusTypeId: false, 
    },
    columnOrder: tableState?.columnOrder ?? [],
    sorting: tableState?.sorting ?? [],
    pagination: tableState?.pagination,
  };

  if (index > -1) {
    // Update existing
    allSettings[index].savedSettings = savedSettings;
  } else {
    // Add new
    allSettings.push({ userRole, selectedTab, savedSettings });
  }
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(allSettings));
}

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
};




  